import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db, auth } from '../../firebase';
import './BalanceOverview.css';

function BalanceOverview() {
  const [balances, setBalances] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isHidden, setIsHidden] = useState(true);
  const user = auth.currentUser;

  useEffect(() => {
    if (!user) return;

    const loadBalances = async () => {
      try {
        const balancesDocRef = doc(db, 'users', user.uid, 'balances', 'balances');
        const docSnapshot = await getDoc(balancesDocRef);

        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          
          // Convert to array
          const balancesArray = Object.keys(data).map(accountName => ({
            account: accountName,
            balance: data[accountName] || 0
          }));

          // Sort by balance descending
          balancesArray.sort((a, b) => b.balance - a.balance);
          
          setBalances(balancesArray);
        }
        
        setLoading(false);
      } catch (error) {
        console.error('Error loading balances:', error);
        setLoading(false);
      }
    };

    loadBalances();
  }, [user]);

  const calculateTotal = () => {
    return balances.reduce((sum, item) => sum + (item.balance || 0), 0);
  };

  const formatAmount = (amount) => {
    if (isHidden) {
      return '£****.**';
    }
    
    const num = parseFloat(amount) || 0;
    const absNum = Math.abs(num);
    const formatted = absNum.toLocaleString('en-GB', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    
    if (num < 0) {
      return `-£${formatted}`;
    }
    return `£${formatted}`;
  };

  const getBalanceColor = (balance) => {
    if (balance > 0) return 'positive';
    if (balance < 0) return 'negative';
    return 'zero';
  };

  if (loading) {
    return (
      <div className="widget balance-overview">
        <div className="widget-header">
          <h3>💰 Balance Overview</h3>
        </div>
        <div className="widget-loading">Loading balances...</div>
      </div>
    );
  }

  const totalBalance = calculateTotal();

  return (
    <div className="widget balance-overview">
      <div className="widget-header">
        <h3>💰 Balance Overview</h3>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <button 
            className="btn-toggle-visibility"
            onClick={() => setIsHidden(!isHidden)}
          >
            {isHidden ? '👁️ Show' : '🙈 Hide'}
          </button>
          <div className={`total-balance ${getBalanceColor(totalBalance)}`}>
            {formatAmount(totalBalance)}
          </div>
        </div>
      </div>

      {balances.length === 0 ? (
        <div className="empty-message">No account balances found.</div>
      ) : (
        <div className="balances-table-wrapper">
          <table className="balances-table">
            <thead>
              <tr>
                <th>Account</th>
                <th>Balance</th>
              </tr>
            </thead>
            <tbody>
              {balances.map((item, index) => (
                <tr key={index}>
                  <td className="account-name-cell">{item.account}</td>
                  <td className={`account-balance-cell ${getBalanceColor(item.balance)}`}>
                    {formatAmount(item.balance)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default BalanceOverview;